function LoadingBar(props) {
	return (
		<div className="loading-bar">
			<div className="indicator" />
		</div>
	)
}

export default LoadingBar;
